'use client';

import Link from 'next/link';

export default function ArtError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center px-4">
        <h1 className="text-4xl font-bold mb-4">Artwork not found</h1>
        <p className="text-muted-foreground mb-8 max-w-md mx-auto">
          This artwork could not be loaded. It may have been moved or removed.
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => reset()}
            className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity"
          >
            Try again
          </button>
          <Link
            href="/art"
            className="px-6 py-3 border border-border rounded-lg hover:bg-accent transition-colors"
          >
            View all art
          </Link>
        </div>
      </div>
    </div>
  );
}
